import React from 'react';
import PropTypes from 'prop-types';
import ModalContainer from './ModalContainer';
import ConfirmModal from './ConfirmModal';
import ContentList from '../Lists/ContentList';
import VerticalTextLockup from '../Typography/VerticalTextLockup';
import ContentIconType from '../Icons/ContentIconType';
import contentTypeName from '../../../utils/contentTypeName';
import { capitalizeFirstLetter } from '../../../utils/stringConversion';
import { buildLink } from '../../../utils/buildLink';

const DeleteContentConflictModal = ({ modalIsOpen, loading, contentConflicts, onConfirmClick, onCloseClick, contentType }) => {
  const contentTypeReadable = contentTypeName(contentType);

  return (
    <ModalContainer
      isOpen={modalIsOpen}
      closeModal={onCloseClick}
      label={`Delete ${contentTypeReadable} modal`}
    >
      <ConfirmModal
        title={`${capitalizeFirstLetter(contentTypeReadable)} in use`}
        confirmText={`I understand, delete ${contentTypeReadable}`}
        onConfirmClick={onConfirmClick}
        onCloseClick={onCloseClick}
        loading={loading}
      >
        <p>This {contentTypeReadable} is being used in the items listed below. Deleting this {contentTypeReadable} will remove it from these items.</p>

        <div className="diagram-conflict-list">
          <ContentList>
            {contentConflicts.map((listItem) => {
              let contentLink = buildLink(listItem.type);
              contentLink = `${contentLink}/${listItem.id}`;

              return (
                <li key={listItem.id}>
                  <a href={contentLink} target="_blank">
                    <div className="d-flex"><ContentIconType contentType={listItem.type} /></div>
                    <VerticalTextLockup title={<h3 className="like-p">{listItem.title}</h3>} />
                  </a>
                </li>
              );
            })}
          </ContentList>
        </div>
      </ConfirmModal>
    </ModalContainer>
  );
};

DeleteContentConflictModal.propTypes = {
  modalIsOpen: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  contentConflicts: PropTypes.array.isRequired,
  onConfirmClick: PropTypes.func.isRequired,
  onCloseClick: PropTypes.func.isRequired,
  contentType: PropTypes.string.isRequired,
};

export default DeleteContentConflictModal;



// WEBPACK FOOTER //
// ./library/app/components/Global/Modals/DeleteContentConflictModal.js